import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {makeStyles} from '@material-ui/core'
import HealthCenterReportStyle from 'pages/HealthCenter/Report/Style'
import {isoStringToDateString} from 'helpers/dateHelper'
import {HeaderReportResponse} from 'api/languageApi'
import {simpleSanitizeHTML} from 'helpers/analysisHelper'

const useStyles = makeStyles(HealthCenterReportStyle)

type PropsType = {
  title: string
  content: string
  name: string
  sex: string
  birthday: string
  measurementDate: string
  textHeader?: HeaderReportResponse
  isLocalLanguage: boolean
  subTitle?: string
  eceo: string
  isShowEceo?: boolean
}
type EyeStatusKey = 'EC' | 'EO' | 'EC/EO'
const HeaderReport = ({
  title,
  content,
  name,
  sex,
  birthday,
  measurementDate,
  textHeader,
  isLocalLanguage,
  subTitle,
  eceo,
  isShowEceo = true,
}: PropsType) => {
  const {t} = useTranslation()
  const classes = useStyles()
  const calculateAge = (birthDateString: string) => {
    const birthDate = new Date(birthDateString)
    const today = new Date()

    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age -= 1
    }

    return age
  }

  const renderEyeStatus = (item: string) => {
    const validKeys: EyeStatusKey[] = ['EC', 'EO', 'EC/EO']
    if (!validKeys.includes(item as EyeStatusKey)) return '-'
    const keyMap: Record<EyeStatusKey, string> = {
      EC: 'IEC',
      EO: 'IEO',
      'EC/EO': 'IECEO',
    }
    const typedItem = item as EyeStatusKey
    return !isLocalLanguage
      ? textHeader?.eyes_status?.value[typedItem] ?? '-'
      : t(keyMap[typedItem])
  }

  const TABLE = useMemo(() => {
    if (isLocalLanguage) {
      return [
        [t('IHeaderPatient'), name],
        [t('IGender'), sex],
        [
          t('IBirthdayV1'),
          birthday ? `${birthday} (${calculateAge(birthday)} Y)` : '',
        ],
        [t('IMeasurementDate'), isoStringToDateString(measurementDate, true)],
        ...(isShowEceo ? [[t('IECEO'), renderEyeStatus(eceo)]] : []),
      ]
    }
    if (textHeader) {
      return [
        [textHeader?.name?.title ?? '', name],
        [textHeader?.sex?.title ?? '', sex],
        [
          textHeader?.birth?.title ?? '',
          birthday
            ? `${birthday} (${calculateAge(birthday)}${t(
                'IEEGSummaryReportChildBrainAgeYear',
              )})`
            : '',
        ],
        [
          textHeader?.measurement?.title?.eeg ?? '',
          isoStringToDateString(measurementDate),
        ],
        ...(isShowEceo
          ? [[textHeader?.eyes_status?.title ?? '', renderEyeStatus(eceo)]]
          : []), // Thêm tham số eceo ở đây
      ]
    }
    return []
  }, [
    t,
    name,
    sex,
    birthday,
    measurementDate,
    eceo,
    textHeader,
    isLocalLanguage,
    isShowEceo,
  ]) // Thêm eceo vào dependency list nếu nó được sử dụng trong useMemo

  return (
    <div className={classes.header}>
      <div className={classes.leftHeader2}>
        <div className={classes.leftHeaderTitle2}>{title}</div>
      </div>
      <div className={classes.rightHeaderV1}>
        <div
          className={classes.leftHeaderContentV1}
          // @ts-ignore
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: simpleSanitizeHTML(String(content)),
          }}
        />
        <div className={classes.tableV1}>
          {TABLE.map((item) => (
            <div className={classes.row} key={item[0]}>
              <div className={classes.headCell}>{item[0]}</div>
              <div className={classes.bodyCell} style={{maxWidth: 200}}>
                {item[1]}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
export default HeaderReport
